import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { IntegrationFormValues } from './useIntegrationCard';
import FormInputText from '@ui/form/input/FormInputText';
import FormButton from '@ui/button/FormButton';
import { IntegrationCredential } from '@app/model/integration-settings/Integration';
import { formatDate } from '../IntegrationSettings.utilities';

// The write-only key or token (decision 5). A saved value never comes back from the API: the field shows dots,
// the save date and the user. "Replace" opens an empty field; the old value stays until a save with a passed test.
const CredentialField: React.FunctionComponent<{
	form: UseFormReturn<IntegrationFormValues>,
	label: string,
	providerLabel: string,
	credential: IntegrationCredential | null,
	isReplacing: boolean,
	onReplace: (replacing: boolean) => void,
}> = ({ form, label, providerLabel, credential, isReplacing, onReplace }) => {
	const isSaved = credential !== null && credential.saved;
	if (isSaved && !isReplacing) {
		const savedBy = credential.savedBy === null ? '' : ` by ${credential.savedBy}`;
		return <div>
			<div className="flex items-end gap-x-2">
				<div className="min-w-0 flex-1">
					<FormInputText form={form} name="credentialMask" label={label} disabled />
				</div>
				<FormButton state="white" onClick={() => onReplace(true)}>Replace</FormButton>
			</div>
			<p className="help">Saved on {formatDate((credential.savedAt ?? '').slice(0, 10))}{savedBy}. RoomPulse never shows it.</p>
		</div>;
	}
	return <div>
		<div className="flex items-end gap-x-2">
			<div className="min-w-0 flex-1">
            <FormInputText form={form} name="credential" type="password" label={label} placeholder={`Paste the value from ${providerLabel}`} />
			</div>
            {isSaved && <FormButton state="text" onClick={() => {
                form.setValue('credential', '', { shouldDirty: true });
                onReplace(false);
            }}>Cancel</FormButton>}
		</div>
		<p className="help">{isSaved ? 'The old value stays until the test passes and you save.' : 'RoomPulse encrypts it at the save.'}</p>
	</div>;
};

export default CredentialField;
